import API from '../api'
import { 
    GET_STORES_REQUEST,
    GET_STORES_SUCCESS,
    GET_STORES_FAIL,
    GET_STORE_REQUEST,
    GET_STORE_SUCCESS,
    GET_STORE_FAIL,
    GET_ALL_STORES_REQUEST,
    GET_ALL_STORES_FAIL,
    GET_ALL_STORES_SUCCESS,
} from "../constants/storesConstants";

export const getStores = () => async (dispatch) => {
    try {
        dispatch({ type: GET_STORES_REQUEST })
        const { data } = await API.get('/stores/mine')
        if(!data.ok) throw new Error(data.message)
        dispatch({ type: GET_STORES_SUCCESS, payload: data.stores })
    } catch (error) {
        dispatch({ type: GET_STORES_FAIL, payload: error.response && error.response.data.message ? error.response.data.message : error.message })
    }
}

export const getAllStores = ({
    showDeleted = true,
    showInactive = true,
    showNoVisible = true,
    search,
    page,
    limit
}) => async (dispatch) => {
    try {
        dispatch({ type: GET_ALL_STORES_REQUEST })
        const queryString = `?showDeleted=${showDeleted}&showInactive=${showInactive}&showNoVisible=${showNoVisible}&search=${search}&page=${page}&limit=${limit}`
        const { data } = await API.get('/stores/all' + queryString)
        if(!data.ok) throw new Error(data.message)
        dispatch({ type: GET_ALL_STORES_SUCCESS, 
            payload: data
        })
    } catch (error) {
        dispatch({ type: GET_ALL_STORES_FAIL, payload: error.response && error.response.data.message ? error.response.data.message : error.message })
    }
}


export const getStore = (slug) => async (dispatch) => {
    try {
        dispatch({ type: GET_STORE_REQUEST })
        const { data } = await API.get(`/stores?slug=${slug}`)
        if(!data.ok) throw new Error(data.message)
        dispatch({ type: GET_STORE_SUCCESS, payload: data.store[0] || false })
    } catch (error) {
        dispatch({ type: GET_STORE_FAIL, payload: error.response && error.response.data.message ? error.response.data.message : error.message })
    }
}